import * as React from 'react';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Modal } from '@mui/material';
import SourceVariableModel from './SourceVariableModel';
import { Identifier, RaRecord, useListContext } from 'react-admin';
import {
    SelectInput,
    ReferenceInput,
    List,
    BooleanField,
    TextInput,
    TextField,
    NumberField,
    Datagrid,
    CreateButton,
    TopToolbar
} from 'react-admin';
import { RaPagination } from '../../components/ra-list/RaList';
import RaExporter from '../../components/ra-list/RaExporter';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const PostListActions: React.FC<any> = ({ onCreate }) => {
    const { filter, sort, resource } = useListContext();
    return (
        <Box width="100%">
            <TopToolbar>
                <CreateButton onClick={onCreate} />
                <RaExporter resource={resource}
                    exportFile={{ columns: ['id', 'SourceType', 'VariableName', 'IsExact', 'InsertInHoursAgo', 'FromDay', 'Today', 'Active'] }}
                    params={{ filter, sort }} />
            </TopToolbar>
        </Box>
    );
};

// Module-scoped, mirroring the same pattern used in ../order-adjust-rule/view.js:
// tracks whether the modal was opened for edit vs. create, read by SourceVariableModel.
let isEdit: boolean;

const SourceVariableList: React.FC = () => {
    const [openEdit, setOpenEdit] = useState(false);
    const [sourceVariable, setSourceVariable] = useState<RaRecord | null>(null);
    const navigate = useNavigate();
    const updateSubmitModel = useCallback(() => {
        handleClose();
    }, []);

    const postFilters = [
        <TextInput label="Upstream" source="id" alwaysOn />,
        <ReferenceInput source='sourceType' reference='Common/SoureTypes' sort={{ field: 'name', order: 'ASC' }} alwaysOn >
            <SelectInput optionText="name" /></ReferenceInput>,
        <TextInput source="VariableName" alwaysOn />,
    ];
    const handleRowClick = (id: Identifier, resource: string, record: RaRecord): false => {
        isEdit = true;
        setOpenEdit(true);
        setSourceVariable(record);
        window.history.replaceState(null, '', `SourceVariable/${id}`);
        return false;
    };
    const handleCreate = (): void => {
        isEdit = false;
        setOpenEdit(true);
    };

    const handleClose = useCallback(() => {
        navigate('/SourceVariable');
        setOpenEdit(false);
        setSourceVariable(null);
    }, [navigate]);

    return (
        <Box>
            <List title="Source variables"
                perPage={25}
                pagination={<RaPagination />}
                storeKey={false}
                disableSyncWithLocation
                // sort={{ field: 'Upstream', order: 'ASC' }}
                filters={postFilters}
                actions={<PostListActions onCreate={handleCreate} />}
            >
                <Datagrid bulkActionButtons={false} rowClick={handleRowClick}>
                    <TextField label="Upstream" source="id" />
                    <TextField label="Source Type" source="sourceType" />
                    <TextField label="Variable Name" source="variableName" />
                    <TextField label="Is Exact" source="isExact" />
                    <NumberField label="Insert In Hours Ago" source="insertInHoursAgo" />
                    <NumberField label="From Day" source="fromDay" />
                    <NumberField label="ToDay" source="today" />
                    <BooleanField label="Active" source="active" />
                </Datagrid>
            </List>
            <Modal
                open={openEdit}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    {openEdit && <SourceVariableModel isEdit={isEdit} onCancel={handleClose} updateModel={updateSubmitModel} id={sourceVariable?.id} />}
                </Box>
            </Modal>
        </Box>
    );
};
const SourceVariablePage = {
    name: 'SourceVariable',
    list: SourceVariableList,
};

export default SourceVariablePage;
